import React from 'react';
import { Button, Space } from 'antd';
import { PlusCircleOutlined, DeleteOutlined } from '@ant-design/icons';

const ServiceHeader = ({ userRole, service, onClaimService, onDeleteService }) => {
  return (
    <div className="block-header">
      <div className="row">
        <div className="col-lg-7 col-md-6 col-sm-12">
          <h2>Service Details</h2>
        </div>
        <div className="col-lg-5 col-md-6 col-sm-12">
          <Space className="float-right">
            {userRole === 'business' && !service?.claimed && (
              <Button 
                type="primary" 
                icon={<PlusCircleOutlined />} 
                onClick={onClaimService}
              >
                Claim Service
              </Button>
            )}
            {userRole === 'admin' && (
              <Button 
                type="primary" 
                danger
                icon={<DeleteOutlined />} 
                onClick={onDeleteService}
              >
                Delete Service
              </Button>
            )}
          </Space>
        </div>
      </div>
    </div>
  );
};

export default ServiceHeader; 